import { EmployeeRestaurant } from './user-context';
import { useMemo } from 'react';
import { useUserOverrides } from './user-overrides-context';

export const useOverrideActiveRestaurant = (
  restaurantRelationship?: EmployeeRestaurant | null,
) => {
  const overrides = useMemo(
    () => ({
      ...(restaurantRelationship
        ? {
            selectedRestaurantRelationship: restaurantRelationship,
            selectedRestaurantUUID: restaurantRelationship.uuid,
          }
        : {}),
    }),
    [restaurantRelationship],
  );
  useUserOverrides(overrides);
};
